<ui-progress-bar
	[percentage]="ocrProcessingPercentage$ | async"
	[message]="currentProgressMessage$ | async"
	[messagePosition]="messagePosition"
></ui-progress-bar>
